import * as React from 'react';

import { AndroidIcon, GalleryIcon, GalaxyIcon, IosIcon, TgIcon, TiktokIcon, YoutubeIcon, InstagramIcon } from '@icons';

import { IconName } from './types.ts';



const iconMap: Record<IconName, React.ReactNode> = {
	android: <AndroidIcon />,
	gallery: <GalleryIcon />,
	galaxy: <GalaxyIcon />,
	ios: <IosIcon />,
	tg: <TgIcon />,
	tiktok: <TiktokIcon />,
	youtube: <YoutubeIcon />,
	instagram: <InstagramIcon />
};

export const getIcon = (name: IconName): React.ReactNode => iconMap[name] || null;